module.exports = __webpack_public_path__ + "static/atlaskit-table-pagination-2614d7e24e985c82c846fd1ae6f33e61.png";